export function unique(elements) {
    function uniqueFilter(value, index, self) {
        return self.indexOf(value) === index;
    }
    return elements.filter(uniqueFilter);
}
